
























































import $store from "@/store/store";
import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import { RapportFav, TypeRapport } from "@/shared/Rapport";
import { Groupe } from "@/shared/Groupe";
import { Site } from "@/shared/Site";
import MobileMixin from "@/mixins/mobileMixin";
import { Prop } from "vue-property-decorator";

@Component({})
export default class OneFavoris extends mixins(MobileMixin) {
  @Prop() public monFavoris!: RapportFav;
  @Prop() public editFavs!: boolean;

  public makeMyReport(rapport: RapportFav) {
    this.$emit("makeMe", rapport);
  }

  public configMe(fav: any) {
    this.$store.dispatch("rapport/updateSelectedFavoris", fav).then((_) => {
      this.$router.push("/configFavoris");
    });
  }

  public isEditing(fav: any) {
    const res = fav.id === this.monFavoris.id;
    return res;
  }

  public removeMe(rapport: any) {
    this.$store.dispatch("rapport/removeFavoris", rapport);
  }

  public mounted() {
    // console.log("bonjour je suis un favoris", this.monFavoris);
  }

  // computed
  get fav(): any {
    return this.monFavoris;
  }
}
